<script lang="ts" generics="T extends string | number">
  // ============================================================
  // <SegmentedControl>  —  toggle control 2-N opciones.
  //
  // Reemplazo idiomatico de los segmented controls inline que se
  // repetian en /vix (timeframe 1m|5m) y similares.
  //
  // Sigue DESIGN.md:
  //   - bg-card + border (mismo aspecto que Input / Button outline)
  //   - active: bg-primary/15 text-primary (mismo lenguaje que toggles
  //     existentes en LiveMonitor y ChartAnalysis)
  //   - inactivo: text-muted-foreground, hover -> text-foreground
  //   - tabular-nums + uppercase para opciones de tamano (m/s/lg/etc)
  //
  // Generic <T>: las options pueden ser strings ('1m'|'5m') o numeros.
  // ============================================================

  interface Option<TVal extends string | number> {
    value: TVal;
    label: string;
  }

  interface Props {
    options: Array<Option<T>>;
    value: T;
    onChange: (v: T) => void;
    ariaLabel?: string;
  }

  let { options, value, onChange, ariaLabel = 'Segmented control' }: Props = $props();
</script>

<div
  role="radiogroup"
  aria-label={ariaLabel}
  class="border-border bg-card inline-flex h-9 items-center rounded-md border p-0.5"
>
  {#each options as opt (opt.value)}
    {@const active = opt.value === value}
    <button
      type="button"
      role="radio"
      aria-checked={active}
      class={[
        'h-8 rounded px-3 text-xs font-medium uppercase tracking-wider tabular-nums transition-colors',
        active
          ? 'bg-primary/15 text-primary'
          : 'text-muted-foreground hover:text-foreground',
      ].join(' ')}
      onclick={() => onChange(opt.value)}
    >
      {opt.label}
    </button>
  {/each}
</div>
